import { type FC } from 'react';
import { z } from 'zod';
import styles from './HotelPreOpening.module.css';

const HotelPreOpening: FC<HotelPreOpeningProps> = ({ firstOpen }) => {
  return (
    <div className={styles.container}>
      <p className="demi-bold">Expected opening</p>
      <p className={styles.date}>{firstOpen}</p>
      <p className={styles.contact}>
        Register your interest by contacting{' '}
        <a
          href="mailto:bookings@littleemperors.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          bookings@littleemperors.com
        </a>
      </p>
    </div>
  );
};

export default HotelPreOpening;

const HotelPreOpeningSchema = z.object({ firstOpen: z.string() });
type HotelPreOpeningProps = z.infer<typeof HotelPreOpeningSchema>;
